export default __webpack_public_path__ + "static/media/@rafasilveriob.21b0e4c8.png";